import { createBrowserRouter } from "react-router"

import App from "./App"
import AboutContent from "./Sections/Loading/AboutContent"

const router = createBrowserRouter([
  {
    path: "/",
    Component: App,
    children: [
      {
        path: "about",
        Component: AboutContent,
      },
      {
        path: ":project",
        Component: () => null,
      },
    ],
  },
])

export default router
